import {
  dashboard_styles_default
} from "./chunk.6HXFP4W3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/dashboard/dashboard.ts
var FadvDashboard = class extends s {
  constructor() {
    super(...arguments);
    this.variant = "primary";
  }
  render() {
    return $`<div class=${o({
      dashboard: true,
      "dashboard--active": this.active,
      "dashboard--primary": this.variant === "primary",
      "dashboard--secondary": this.variant === "secondary",
      "dashboard--tertiary": this.variant === "tertiary",
      "dashboard--neutral": this.variant === "neutral",
      "dashboard--success": this.variant === "success",
      "dashboard--warning": this.variant === "warning",
      "dashboard--danger": this.variant === "danger"
    })} role="dashboard" ><div class="dashboard__container"><fadv-badge pill="true" variant="${this.variant}"></fadv-badge><fadv-typography class="dashboard__title" type="label-medium" weight="500">${this.heading}</fadv-typography><div class="dashboard__content"><fadv-typography class="dashboard__value" type="heading-large" weight="500">${this.value}</fadv-typography><fadv-typography class="dashboard__sub-value" type="label-small" weight="500" variant="${this.variant}">${this.subValue}</fadv-typography></div></div></div>`;
  }
};
FadvDashboard.styles = dashboard_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvDashboard.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], FadvDashboard.prototype, "heading", 2);
__decorateClass([
  e({ reflect: true })
], FadvDashboard.prototype, "value", 2);
__decorateClass([
  e({ reflect: true })
], FadvDashboard.prototype, "subValue", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvDashboard.prototype, "active", 2);
FadvDashboard = __decorateClass([
  n("fadv-dashboard")
], FadvDashboard);

export {
  FadvDashboard
};
